const model = [
  {
    key: 'campaignId',
    label: 'Campaign Id',
    minWidth: 100,
  },
  {
    key: 'legacyPostId',
    label: 'Product Id',
    minWidth: 90,
  },
  {
    key: 'sku',
    label: 'SKU',
    minWidth: 100,
  },
  {
    key: 'productName',
    label: 'Product Name',
    minWidth: 275,
    type: 'string',
  },
  {
    key: 'variantDescriptorsDisplay',
    label: 'Product Descriptors',
    minWidth: 145,
    type: 'string',
    editable: true,
  },
  {
    key: 'categoryIds',
    label: 'Categories',
    minWidth: 200,
    type: 'list',
    inputType: 'categoryChecklist',
  },
  {
    key: 'galleryUrls',
    label: 'Gallery Images',
    type: 'list',
    minWidth: 130,
  },
  {
    key: 'imageUrl',
    label: 'Thumbnail Image',
    minWidth: 130,
    type: 'string',
  },
  {
    key: 'isDeleted',
    label: 'Removed From Sale',
    minWidth: 150,
    type: 'boolean',
    inputType: 'dropdownBoolean',
  },
  {
    key: 'stockTotal',
    label: 'Total Stock',
    minWidth: 90,
    type: 'number',
    inputType: 'input',
  },
  {
    key: 'stockOut',
    label: 'Min Threshold',
    minWidth: 110,
    type: 'number',
    inputType: 'input',
  },
  {
    key: 'stockLow',
    label: 'Stock Low Threshold',
    minWidth: 160,
    type: 'number',
    inputType: 'input',
  },
  {
    key: 'cartLimit',
    label: 'Cart Limit',
    minWidth: 85,
    type: 'number',
    inputType: 'input',
  },
  {
    key: 'shippingRestrictionsDisplay',
    label: 'Shipping Restrictions',
    minWidth: 155,
    type: 'string',
  },
  {
    key: 'retailPrice',
    label: 'Retail Price',
    minWidth: 100,
    type: 'number',
  },
  {
    key: 'salePrice',
    label: 'Sale Price',
    minWidth: 100,
    type: 'number',
    inputType: 'input',
  },
  {
    key: 'isSponsored',
    label: 'Sponsored Product',
    minWidth: 155,
    type: 'boolean',
    inputType: 'dropdownBoolean',
  },
  {
    key: 'gwpThreshold',
    label: 'GWP Threshold',
    minWidth: 155,
    type: 'number',
    inputType: 'input',
  },
  {
    key: 'ordering',
    label: 'Featured Order',
    minWidth: 120,
    type: 'number',
  },
  {
    key: 'isTaxExempt',
    label: 'Is Tax Exempt',
    minWidth: 120,
    type: 'boolean',
    inputType: 'dropdownBoolean',
  },
  {
    key: 'isShippingExempt',
    label: 'Is Shipping Exempt',
    minWidth: 150,
    type: 'boolean',
    inputType: 'dropdownBoolean',
  },
  {
    key: 'isSubscribable',
    label: 'Is Subscribable',
    minWidth: 120,
    type: 'boolean',
    inputType: 'dropdownBoolean',
  },
  {
    key: 'isPublicRefill',
    label: 'Public Subscription',
    minWidth: 160,
    type: 'boolean',
    inputType: 'dropdownBoolean',
  },
  {
    key: 'productPreviewUrl',
    label: 'Product Preview Url',
    minWidth: 160,
  },
];

export default model;
